export default __webpack_public_path__ + "static/media/nkem.5da5bea6.png";